<template>
    <div class="codics-aonaer-info-sys-breadcrumb">
        <span v-show="icon != ''" class="iconfonts codics-aonaer-info-sys-breadcrumb-box-item" v-html="icon"></span>
        <div class="codics-aonaer-info-sys-breadcrumb-box-item" v-for="(item, index) in breadList" :key="index">
            <span class="codics-aonaer-info-sys-breadcrumb-box-item-title" @click="changePage(item)"
                :style="{ 'color': index + 1 == breadList.length ? 'var(--sbar-font-color) !important' : 'var(--sbar-font-hint-color)', 'pointer-events': index + 1 == breadList.length ? 'none' : 'all' }">{{
                    item?.title }}</span>
            <span style="padding: 0 0 0 10px;" v-show="index + 1 != breadList.length">-</span>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        icon: {
            type: String,
            default: ''
        },
        breadList: {
            type: Array,
            default: () => {
                return [
                    {
                        title: '网站首页',
                        url: '#'
                    }
                ];
            }
        }
    },
    methods: {
        changePage(item) {
            this.$router.push({ name: item.title, params: item?.p || {}, query: item?.q || {} }, () => { }, () => { });
        }
    }
}
</script>

<style>
.codics-aonaer-info-sys-breadcrumb {
    height: 50px;
    width: fit-content;
    position: relative;
    float: left;
    box-sizing: border-box;
    font-size: 12px;
    padding: 0 20px;
    font-weight: bold;
    transition: .3s;
}

.codics-aonaer-info-sys-breadcrumb-box-item {
    height: 100%;
    width: fit-content;
    position: relative;
    float: left;
    line-height: 50px;
    text-align: center;
    box-sizing: border-box;
    padding: 0 10px 0 0;
    user-select: none;
    transition: .3s;
    user-select: none;
    color: var(--sbar-font-color);
    -webkit-user-drag: none;
}

.codics-aonaer-info-sys-breadcrumb-box-item-title {
    transition: .3s;
    cursor: pointer;
}

.codics-aonaer-info-sys-breadcrumb-box-item .codics-aonaer-info-sys-breadcrumb-box-item-title:hover {
    color: #333 !important;
    color: var(--sbar-font-hover-color) !important;
}
</style>